// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 107,
  argument: "The prophet praiseth God for benefits received.",
  verses: [
    { n: 1, text: "A canticle of a psalm for David himself." },
    { n: 2, text: "My heart is ready, O God, my heart is ready: I will sing, and will give praise, with my glory." },
    { n: 3, text: "Arise, my glory; arise, psaltery and harp: I will arise in the morning early." },
    { n: 4, text: "I will praise thee, O Lord, among the people: and I will sing unto thee among the nations." },
    { n: 5, text: "For thy mercy is great above the heavens: and thy truth even unto the clouds." },
    { n: 6, text: "Be thou exalted, O God, above the heavens, and thy glory over all the earth: 7 that thy beloved may be delivered. Save with thy right hand and hear me." },
    { n: 8, text: "God hath spoken in his holiness: I will rejoice, and I will divide Sichem: and I will mete out the vale of tabernacles." },
    { n: 9, text: "Galaad is mine, and Manasses is mine: and Ephraim the protection of my head. Juda is my king:" },
    { n: 10, text: "Moab the pot of my hope. Over Edom I will stretch out my shoe: the aliens are become my friends." },
    { n: 11, text: "Who will bring me into the strong city? who will lead me into Edom?" },
    { n: 12, text: "Wilt not thou, O God, who hast cast us off? and wilt not thou, O God, go forth with our armies?" },
    { n: 13, text: "O grant us help from trouble: for vain is the help of man." },
    { n: 14, text: "Through God we shall do mightily: and he will bring our enemies to nothing." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Himself. By repeating here what occurs in Psalm lvi., and lix. David teaches us to excite our fervour by such sentiments as have formerly made an impression upon us. (Berthier) — He spoke before of his own victories: now he considers those of Christ, and of his Church, (Genebrard) as well as the state of the captives. (Theodoret)", attribution: "Calmet" }
    ] },
    { verse: 2, notes: [
      { text: "My heart, &c. Is not repeated in Hebrew. But it is, [in] Psalm lvi. 8.", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "Arise, my glory. Is found also in this psalm, though not here in Hebrew, &c. St. Jerome (ad Sun.) thinks some copyist has inserted it. (Calmet) — But it seems to be here in its proper place.", attribution: "Berthier" }
    ] },
    { verse: 4, notes: [
      { text: "Nations. David made various conquests, which prefigured those of Christ, to whom the rest of the psalm belongs. (St. Augustine)", attribution: "Worthington" }
    ] },
    { verse: 7, notes: [
      { text: "That. See Psalm lix. 7.", attribution: "Worthington" }
    ] },
    { verse: 8, notes: [
      { text: "Holiness. Or holy one, sancto: (Haydock) meaning Jeremias xxv. 11., who foretold the end of the captivity, (Calmet) or David himself, and the Messias, his son, in whom he will rejoice.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
